import { blogs } from "../data/blogs.js";

const byPriorityAsc = (a, b) => {
  // Step 1: Priority
  const pa = a.priority ?? "low";
  const pb = b.priority ?? "low";

  if (pa === "high" && pb !== "high") return -1;
  if (pb === "high" && pa !== "high") return 1;

  // Step 2: Year (newest first)
  const yearA = a.year ?? 0;
  const yearB = b.year ?? 0;
  return yearB - yearA;
};

export default function BlogsPage() {
  const all = [...blogs].sort(byPriorityAsc);

  return (
    <div className="px-4 lg:px-40 md:px-10 py-8">
      <header className="mb-4">
        <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[#0e1b17]">
          Our Activities
        </h1>
        <p className="text-sm text-[#4e977f] mt-1">
          Latest initiatives and support to/from our community (by local media).
        </p>
      </header>

      {/* 4 per row on desktop, responsive on smaller screens */}
      <section className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 gap-4">
        {all.map(({ title, subtitle, image, link }, i) => (
          <article
            key={i}
            className="flex flex-col gap-3 pb-3 rounded-xl shadow-sm bg-white"
          >

            <div className="flex flex-col flex-1 justify-between p-3">
              <div>
                <p className="text-[#0e1b17] text-base font-semibold leading-normal">
                  {title}
                </p>
                <p className="text-[#4e977f] text-sm leading-normal line-clamp-3">
                  {subtitle}
                </p>
              </div>
              {link && (
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-flex items-center justify-center rounded-lg bg-[#14b881] px-3 py-1.5 text-xs font-semibold text-[#0e1b17] hover:bg-[#0fa46f] transition"
                >
                  View
                </a>
              )}
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
